import { memo } from 'react';
import classNames from 'classnames';
import InputTitleLabel from 'components/inputTitleLabel';
import BaseSelectInput from 'components/inputSelect/baseSelectInput';
import { useDeviceSize } from 'hooks/useDeviceSize';

export default memo(
  ({
    title = '',
    formik,
    fieldName,
    value = null,
    onChange = null,
    required = false,
    placeholder = '選択してください',
    suffix = '',
    options = null,
    disabled = false,
    className = { boxClass: '', titleClass: '', inputClass: '' },
    isShowErrorArea = true,
    errorMessage = null,
    isLongError = false,
    minLabelWidth,
  }) => {
    const { isSp } = useDeviceSize();

    // エラーメッセージ生成
    const createErrorMessage = () =>
      errorMessage != null
        ? errorMessage
        : (!disabled &&
            formik &&
            formik?.touched[fieldName] &&
            formik?.errors[fieldName]) ||
          '';

    return (
      <div className={classNames('w-full', className.boxClass)}>
        <div className="flex flex-col gap-y-1">
          <div className="flex flex-row items-end justify-between">
            <InputTitleLabel
              title={title}
              required={required}
              disabled={disabled}
              className={className.titleClass}
              minLabelWidth={minLabelWidth}
            />
            {isShowErrorArea && (
              <label
                className={classNames(
                  'text-sm w-auto justify-end text-right text-red',
                  isLongError && isSp ? 'whitespace-pre-wrap' : ''
                )}
              >
                {createErrorMessage()}
              </label>
            )}
          </div>
          <div className="flex w-full gap-x-2">
            <div
              className={classNames(
                'flex w-full flex-col gap-y-1',
                className.inputClass
              )}
            >
              <span className="flex w-full">
                <BaseSelectInput
                  formik={formik}
                  fieldName={fieldName}
                  placeholder={placeholder}
                  options={options}
                  disabled={disabled}
                  error={!!createErrorMessage()}
                  className={className.inputClass}
                  value={value}
                  onChange={onChange}
                />
                {suffix && (
                  <label
                    className={classNames(
                      'ml-2 self-center',
                      disabled ? 'text-disabled' : 'text-navy'
                    )}
                  >
                    {suffix}
                  </label>
                )}
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  }
);
